/**
 * @file loading 组件入口文件，用于导出 loading 组件
 * @author fanweiwei
 * @date 2023-12-12
 */

import Loading from './Loading.vue';

export default {
  install(_vue) {
    const LoadingConstructor = _vue.extend(Loading);
    let instance;

    const createElement = () => {
      return new LoadingConstructor({
        el: document.createElement('div'),
      });
    };

    _vue.prototype.$coolLoading = {
      show(options) {
        if (!instance) {
          instance = createElement();
          // 添加到页面
          document.body.appendChild(instance.$el);
        }

        if (typeof options === 'string') {
          instance.text = options;
        } else {
          for (const key in options) {
            if (options.hasOwnProperty(key)) {
              const value = options[key];
              instance[key] = value;
            }
          }
        }

        instance.show = true;
      },

      hide(options) {
        if (instance) {
          instance.show = false;
        }
      }
    };
  }
};
